import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, type PropsWithChildren } from "react";
import { ThemeProvider } from "./context/ThemeContext";
import { ErrorBoundary } from "./components/ErrorBoundary";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhatIDo from "./components/WhatIDo";
import FeaturedProjects from "./components/FeaturedProjects";
import ExpertiseGrid from "./components/ExpertiseGrid";
import CertificationsTeaser from "./components/CertificationsTeaser";
import Methodology from "./components/Methodology";
import ConnectCTA from "./components/ConnectCTA";
import Footer from "./components/Footer";

import HowItStarted from "./pages/HowItStarted";
import Certificates from "./pages/Certificates";
import ContactPage from "./pages/ContactPage";
import Skills from "./pages/Skills";
import Blogs from "./pages/Blogs";
import NotFound from "./pages/NotFound";

const ScrollToTop = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <ScrollToTop>
        <div className="flex flex-col min-h-screen bg-light-bg dark:bg-surface-0 transition-colors duration-300">
          <Navbar />

          <main id="main-content" className="flex-1">
            <ErrorBoundary>
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <Hero />
                    <WhatIDo />
                    <FeaturedProjects />
                    <ExpertiseGrid />
                    <CertificationsTeaser />
                    <Methodology />
                    <ConnectCTA />
                  </>
                }
              />
              <Route path="/certificates" element={<Certificates />} />
              <Route path="/about" element={<HowItStarted />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            </ErrorBoundary>
          </main>

          <Footer />
        </div>
      </ScrollToTop>
    </ThemeProvider>
  );
}

export default App;
